/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Wild_Coral_Snake_CallInputs */

const en_wild_coral_snake_call = /** @type {(inputs: Wild_Coral_Snake_CallInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Comments disabled`)
};

const de_wild_coral_snake_call = /** @type {(inputs: Wild_Coral_Snake_CallInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kommentare deaktiviert`)
};

/**
* | output |
* | --- |
* | "Comments disabled" |
*
* @param {Wild_Coral_Snake_CallInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const wild_coral_snake_call = /** @type {((inputs?: Wild_Coral_Snake_CallInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wild_Coral_Snake_CallInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_wild_coral_snake_call(inputs)
	return de_wild_coral_snake_call(inputs)
});